export interface IColorShades {
  25: string;
  50: string;
  100: string;
  200: string;
  300: string;
  400: string;
  500: string;
  600: string;
  700: string;
  800: string;
  900: string;
}

export interface IColorAlertShades {
  light: string;
  medium: string;
  dark: string;
}

export interface IColors {
  primary: IColorShades;
  secondary: IColorShades;
  neutral: IColorShades;
  success: IColorAlertShades;
  warning: IColorAlertShades;
  danger: IColorAlertShades;
  white: string;
}

export const Colors: IColors = {
  primary: {
    25: '#EDE8FC',
    50: '#DCD1FA',
    100: '#CABAF7',
    200: '#A68CF2',
    300: '#9575F0',
    400: '#835EED',
    500: '#6031E8',
    600: '#4617CE',
    700: '#3712A1',
    800: '#270D73',
    900: '#170845',
  },
  secondary: {
    25: '#CCF9FF',
    50: '#99F3FF',
    100: '#66EDFF',
    200: '#33E7FF',
    300: '#00E0FF',
    400: '#00B2D0',
    500: '#0086A3',
    600: '#005C78',
    700: '#003550',
    800: '#00293D',
    900: '#001B29',
  },
  neutral: {
    25: '#FCFCFD',
    50: '#F9FAFB',
    100: '#F2F4F7',
    200: '#E4E7EC',
    300: '#D0D5DD',
    400: '#98A2B3',
    500: '#667085',
    600: '#475467',
    700: '#344054',
    800: '#1D2939',
    900: '#101828',
  },
  success: {
    light: '#D6FFF7',
    medium: '#00E0B7',
    dark: '#054D39',
  },
  warning: {
    light: '#FFF7E5',
    medium: '#FFC033',
    dark: '#8F6300',
  },
  danger: {
    light: '#FEE6E6',
    medium: '#F81616',
    dark: '#720303',
  },
  white: '#FFFFFF',
};
